import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Breadcrumb, Image, Spin, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const CategoryImages = () => {
  const navigate = useNavigate();
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState({});

  useEffect(() => {
    fetch('/api/categorias')
      .then(res => res.json())
      .then(data => {
        setCategorias(data);
        setLoading(false);
      });
  }, []);

  const handleFileChange = (file, categoriaId) => {
    const newFiles = { ...selectedFiles, [categoriaId]: file };
    setSelectedFiles(newFiles);
    return false; // evita upload automático
  };

  const handleUpload = async (categoriaId) => {
  const file = selectedFiles[categoriaId];
  if (!file) {
    message.warning('Selecione uma imagem primeiro.');
    return;
  }

  const formData = new FormData();
  formData.append('imagem', file);

  try {
    const response = await fetch(`/api/categorias/${categoriaId}/imagem`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      message.success(data.message); // mensagem do backend
      // Atualiza visual
      const updatedCategorias = categorias.map(cat => {
        if (cat.ID_CATEGORIA === categoriaId) {
          return { ...cat, IMAGEM: data.imagem }; // usa nome da imagem do backend
        }
        return cat;
      });
      setCategorias(updatedCategorias);
      setSelectedFiles({ ...selectedFiles, [categoriaId]: null });
    } else {
      message.error(data.error || 'Erro ao atualizar imagem.');
    }
  } catch (error) {
    console.error(error);
    message.error('Erro interno ao enviar a imagem.');
  }
};

 return (
  <div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 10,
        marginTop: -10  // sobe o título aproximando ao breadcrumb
      }}
    >
      <Title level={3} style={{ margin: 0 }}>
        Imagens das Categorias
      </Title>

      {/* Botão Categories */}
        <Button type="primary" size="large" onClick={() => navigate('/categories')}>
          Categorias
        </Button>
    </div>
    {loading ? (
      <Spin />
    ) : (
      <Row gutter={[16, 16]}>
        {categorias.map(categoria => (
          <Col xs={24} sm={12} md={8} lg={6} key={categoria.ID_CATEGORIA}>
            <Card
              hoverable
              cover={
                <Image
                  src={
                    selectedFiles[categoria.ID_CATEGORIA]
                      ? URL.createObjectURL(selectedFiles[categoria.ID_CATEGORIA])
                      : `/api/uploads_categorias/${categoria.IMAGEM}`
                  }
                  alt={categoria.NOME}
                  style={{ height: 200, objectFit: 'cover' }}
                  fallback="/api/uploads_categorias/no-image.png"
                />
              }
            >
              <Card.Meta title={categoria.NOME} />

              <div style={{ marginTop: 12 }}>
                <Upload
                  beforeUpload={(file) => handleFileChange(file, categoria.ID_CATEGORIA)}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>Selecionar Nova Imagem</Button>
                </Upload>

                <Button
                  type="primary"
                  style={{ marginTop: 8 }}
                  onClick={() => handleUpload(categoria.ID_CATEGORIA)}
                  disabled={!selectedFiles[categoria.ID_CATEGORIA]}
                >
                  Atualizar Imagem
                </Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    )}
  </div>
);
};

export default CategoryImages;
